/* RelieveFit storefront runtime — relievefit.com (Shopify).
 * A plain-JS port of the Claude Design component ("RelieveFit PDP.dc.html"): same state, same renderVals(),
 * driven over markup compiled by build/compile.js. Style bindings are CSS custom properties (--rf-<key>),
 * text bindings are [data-rf-text], conditionals are <rf-if data-rf-if>, clicks are [data-rf-on-click].
 * Also: add-to-cart (one line per size + the tier's free gifts, bundle price via Shopify automatic discounts)
 * and the cart guard (free gifts follow the number of pairs in the cart).
 * Generated into assets/rf-runtime.js by compile.js; __STYLE_VARS__ is filled in at build time.
 */
(function () {
  var STYLE_VARS = ["endsShow","trustJustify","trustArrowShow","trustShow1","trustAnim","trustDivShow","trustShow2","burgerShow","navShow","logoSize","localeShow","rowGap","leftStick","thumbW","thumbGap","titleSize","rowBg1","b1","d1","e1","o1","m1","rowBg2","b2","d2","e2","o2","m2","rowBg4","b4","d4","e4","o4","m4","giftSq","gOp1","gBlur1","gLock1","gLbl1","gOp2","gBlur2","gLock2","gLbl2","gOp3","gBlur3","gLock3","gLbl3","barY","barO","barP","barPad","barThumbShow","barNameShow","barTextShow","barBtnFlex"];
  var isNode = typeof module !== 'undefined' && module.exports;
  var RF = (!isNode && window.RF) || { img: {}, variants: {}, bag: null, gloveVariantIds: [] };
  function IMG(name) { return (RF.img && RF.img[name]) || ('__IMG:' + name + '__'); }

  var GALLERY_NAMES = ['rf2-g1', 'rf2-g2', 'rf2-g3', 'rf2-g4', 'rf2-g5', 'rf2-g6', 'rf2-g7'];
  // image 1 follows the selected bundle (1 / 2 / 4 pairs); images 2-7 never change
  var HERO = { 1: 'rf2-g1-1', 2: 'rf2-g1', 4: 'rf2-g1-4' };
  var PACKS = {
    1: { price: '$59.00', ppNow: '$59.00', ppCompare: '$99.00', compare: '$99.00', savePct: '40%', per: 'One pair · $59.00 each' },
    2: { price: '$99.00', ppNow: '$49.50', ppCompare: '$99.00', compare: '$198.00', savePct: '50%', per: 'Two pairs · $49.50 each — you save $99.00' },
    4: { price: '$149.00', ppNow: '$37.25', ppCompare: '$99.00', compare: '$396.00', savePct: '62%', per: 'Four pairs · $37.25 each — you save $247.00' }
  };
  var SHORT = { Small: 'S', Medium: 'M', Large: 'L' };

  function addBusinessDays(d, n) {
    var x = new Date(d.getTime()), k = 0;
    while (k < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) k++; }
    return x;
  }
  function fmtDay(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }

  function Component(opts) {
    this.state = { idx: 0, pack: 2, size: 'Medium', sizes: ['Medium', 'Medium', 'Medium', 'Medium'], left: 3, hrs: 11, mins: 42, secs: 18,
                   narrow: !!(opts && opts.narrow), stuck: false, trustIdx: 0, menuOpen: false, sizingOpen: false };
    this.onChange = function () {};
    this.imgEl = null;
    this.staticText = !!(opts && opts.staticText);
  }
  Component.prototype.setState = function (u) {
    var patch = typeof u === 'function' ? u(this.state) : u;
    var prevPack = this.state.pack;
    for (var k in patch) this.state[k] = patch[k];
    if (this.state.pack !== prevPack) { this.state.idx = 0; this.syncHero(); }   // new bundle: show its matching image first
    this.onChange();
  };
  Component.prototype.setPairSize = function (i, v) {
    this.setState(function (s) { var sizes = s.sizes.slice(); sizes[i] = v; return { sizes: sizes, size: sizes[0] }; });
  };
  Component.prototype.galleryName = function (i) { return i === 0 ? HERO[this.state.pack] || GALLERY_NAMES[0] : GALLERY_NAMES[i]; };
  Component.prototype.syncHero = function () {
    var self = this;
    if (typeof document === 'undefined') return;
    if (this.imgEl) this.imgEl.src = IMG(this.galleryName(0));
    var th = document.querySelectorAll('[data-rf-hero-thumb]');
    for (var i = 0; i < th.length; i++) th[i].src = IMG(self.galleryName(0));
  };
  Component.prototype.setIdx = function (i) {
    var n = (i + GALLERY_NAMES.length) % GALLERY_NAMES.length;
    this.setState({ idx: n });
    if (this.imgEl) this.imgEl.src = IMG(this.galleryName(n));
  };
  Component.prototype.pad = function (n) { return String(n).padStart(2, '0'); };
  Component.prototype.deliveryRange = function () {
    if (this.staticText) return 'within 4–9 business days';
    var now = new Date();
    return 'between ' + fmtDay(addBusinessDays(now, 4)) + ' and ' + fmtDay(addBusinessDays(now, 9));
  };

  Component.prototype.renderVals = function () {
    var self = this, st = this.state;
    var p = PACKS[st.pack];
    var sel = '#0f5f6b', off = '#e6e1d9', clear = 'transparent';
    var GIFTS = {
      1: { n: 1, line: 'Travel Pouch + Recovery Plan included — add a 2nd pair to unlock 2 more gifts' },
      2: { n: 3, line: 'All 4 gifts unlocked · $124.96 value' },
      4: { n: 3, line: 'All 4 gifts unlocked · $124.96 value' }
    };
    var g = GIFTS[st.pack];
    var picked = st.sizes.slice(0, st.pack);
    var v = {
      showCountdown: true,
      leftStick: st.narrow ? 'static' : 'sticky',
      menuOpen: !!st.menuOpen,
      toggleMenu: function () { self.setState(function (s) { return { menuOpen: !s.menuOpen }; }); },
      closeMenu: function () { self.setState({ menuOpen: false }); },
      titleSize: st.narrow ? '25px' : '34px',
      endsShow: st.narrow ? 'none' : 'inline',
      thumbW: st.narrow ? '18.4%' : '88px',
      thumbGap: st.narrow ? '7px' : '9px',
      trustAnim: st.narrow ? (st.trustIdx === 0 ? 'rf-fadeA 0.45s ease' : 'rf-fadeB 0.45s ease') : 'none',
      trustArrowShow: st.narrow ? 'block' : 'none',
      trustJustify: st.narrow ? 'space-between' : 'center',
      trustDivShow: st.narrow ? 'none' : 'block',
      trustShow1: st.narrow ? (st.trustIdx === 0 ? 'flex' : 'none') : 'flex',
      trustShow2: st.narrow ? (st.trustIdx === 1 ? 'flex' : 'none') : 'flex',
      trustPrev: function () { self.setState(function (s) { return { trustIdx: s.trustIdx === 0 ? 1 : 0 }; }); },
      trustNext: function () { self.setState(function (s) { return { trustIdx: s.trustIdx === 0 ? 1 : 0 }; }); },
      burgerShow: st.narrow ? 'block' : 'none',
      navShow: st.narrow ? 'none' : 'flex',
      localeShow: st.narrow ? 'none' : 'inline',
      logoSize: st.narrow ? '21px' : '25px',
      rowGap: st.narrow ? '24px' : '44px',
      giftSq: st.narrow ? '86px' : '116px',
      barPad: st.narrow ? '9px 14px' : '11px 22px',
      barThumbShow: st.narrow ? 'none' : 'block',
      barNameShow: st.narrow ? 'none' : 'block',
      barTextShow: st.narrow ? 'none' : 'flex',
      barBtnFlex: st.narrow ? '1 1 auto' : '0 1 260px',
      imgRef: function (el) { self.imgEl = el; if (el) el.src = IMG(self.galleryName(self.state.idx)); if (typeof Image !== 'undefined') for (var p in HERO) { (new Image()).src = IMG(HERO[p]); } },
      counter: (st.idx + 1) + ' / ' + GALLERY_NAMES.length,
      nextImg: function () { self.setIdx(self.state.idx + 1); },
      prevImg: function () { self.setIdx(self.state.idx - 1); },
      pick0: function () { self.setIdx(0); }, pick1: function () { self.setIdx(1); }, pick2: function () { self.setIdx(2); },
      pick3: function () { self.setIdx(3); }, pick4: function () { self.setIdx(4); }, pick5: function () { self.setIdx(5); },
      pick6: function () { self.setIdx(6); },
      days: this.pad(st.left), hrs: this.pad(st.hrs), mins: this.pad(st.mins), secs: this.pad(st.secs),
      deliveryRange: this.deliveryRange(),
      barY: st.stuck ? '0%' : '100%',
      barO: st.stuck ? 1 : 0,
      barP: st.stuck ? 'auto' : 'none',
      barMeta: ({ 1: '1 pair', 2: '2 pairs', 4: '4 pairs' })[st.pack] + ' · ' + picked.map(function (s) { return SHORT[s]; }).join('/'),
      jumpToBuy: function () {
        var el = document.getElementById('pricing');
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: 'smooth' });
      },
      giftsLine: g.line,
      gNm1: g.n >= 1 ? 'FREE Travel Pouch' : 'Travel Pouch',
      gNm2: g.n >= 2 ? 'FREE Survival Guide' : 'Survival Guide',
      gNm3: g.n >= 3 ? 'FREE Wash Bag' : 'Zipper Wash Bag',
      gLbl1: '#b3402c', gLbl2: '#b3402c', gLbl3: '#b3402c',
      gImg1: IMG('rf-gift-travel-pouch'), gImg2: IMG('rf-gift-survival-guide'), gImg3: IMG('rf-gift-zip-washbag'),
      gVal1: '$14.99', gVal2: '$49.99', gVal3: '$19.99',
      sizeHeading: st.pack === 1 ? 'Size' : 'Sizes',
      sizeSummary: (function () {
        var counts = {}; picked.forEach(function (s) { counts[s] = (counts[s] || 0) + 1; });
        var keys = Object.keys(counts);
        if (st.pack === 1) return picked[0];
        if (keys.length === 1) return picked[0] + ' × ' + st.pack;
        return ['Small', 'Medium', 'Large'].filter(function (k) { return counts[k]; }).map(function (k) { return SHORT[k] + ' × ' + counts[k]; }).join(', ');
      })(),
      qty: st.pack,
      sizeCsv: picked.join(','),
      cartLine: 'Adding ' + st.pack + ' × ' + picked.map(function (s) { return SHORT[s]; }).join(' + ') + ' · Bamboo Light Grey',
      ck1: st.pack === 1, ck2: st.pack === 2, ck4: st.pack === 4,
      sizeRows: picked.map(function (s, i) { return { size: s, sizeLabel: 'Size for pair ' + (i + 1) }; }),
      sizingOpen: !!st.sizingOpen,
      openSizing: function (e) { if (e && e.preventDefault) e.preventDefault(); self.setState({ sizingOpen: true }); },
      closeSizing: function () { self.setState({ sizingOpen: false }); },
      stop: function () {},
      gClick1: function () {},
      gClick2: function () { self.setState(function (s) { return { pack: Math.max(s.pack, 2) }; }); },
      gClick3: function () { self.setState(function (s) { return { pack: Math.max(s.pack, 2) }; }); },
      gHint1: 'Included free with every order',
      gHint2: g.n >= 2 ? 'Unlocked with 2 pairs' : 'Click to unlock — included with 2 pairs',
      gHint3: g.n >= 3 ? 'Unlocked with 2 pairs' : 'Click to unlock — included with 2 pairs',
      price: p.price, compare: p.compare, ppNow: p.ppNow, ppCompare: p.ppCompare, savePct: p.savePct, perPairLine: p.per,
      setPack1: function () { self.setState({ pack: 1 }); },
      setPack2: function () { self.setState({ pack: 2 }); },
      setPack4: function () { self.setState({ pack: 4 }); },
      b1: st.pack === 1 ? sel : off, b2: st.pack === 2 ? sel : off, b4: st.pack === 4 ? sel : off,
      d1: st.pack === 1 ? sel : clear, d2: st.pack === 2 ? sel : clear, d4: st.pack === 4 ? sel : clear,
      rowBg1: st.pack === 1 ? '#EEF6F7' : '#ffffff', rowBg2: st.pack === 2 ? '#EEF6F7' : '#ffffff', rowBg4: st.pack === 4 ? '#EEF6F7' : '#ffffff',
      e1: st.pack === 1 ? '360px' : '0px', o1: st.pack === 1 ? 1 : 0, m1: st.pack === 1 ? '10px' : '0px',
      e2: st.pack === 2 ? '700px' : '0px', o2: st.pack === 2 ? 1 : 0, m2: st.pack === 2 ? '12px' : '0px',
      e4: st.pack === 4 ? '820px' : '0px', o4: st.pack === 4 ? 1 : 0, m4: st.pack === 4 ? '12px' : '0px',
      size: st.size,
      setS: function () { self.setState({ size: 'Small' }); },
      setM: function () { self.setState({ size: 'Medium' }); },
      setL: function () { self.setState({ size: 'Large' }); },
      sS: st.size === 'Small' ? sel : off, sM: st.size === 'Medium' ? sel : off, sL: st.size === 'Large' ? sel : off
    };
    [1, 2, 3].forEach(function (k) {
      var on = g.n >= k;
      v['gBlur' + k] = on ? 'none' : 'blur(4px)';
      v['gLock' + k] = on ? 'none' : 'flex';
      v['gOp' + k] = on ? 1 : 0.55;
      v['gIc' + k] = on ? '✓' : '+';
      v['gBd' + k] = on ? sel : off;
      v['gBg' + k] = on ? '#eaf3f4' : '#faf8f5';
      v['gSt' + k] = on ? 'UNLOCKED' : 'LOCKED';
      v['gTx' + k] = on ? '#ffffff' : '#37484c';
    });
    return v;
  };

  if (isNode) { module.exports = { Component: Component, IMG: IMG, GALLERY_NAMES: GALLERY_NAMES }; return; }

  /* ------------------------------ browser ------------------------------ */
  if (window.__rfBooted) return;
  window.__rfBooted = true;
  var comp = new Component({ narrow: window.innerWidth < 980 });
  var vals = null, scheduled = false;
  var attrBindings = [];
  var rowTemplates = [];

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function renderRows(v) {
    rowTemplates.forEach(function (rt) {
      var rows = v[rt.key] || [];
      var sig = rows.length + '|' + rows.map(function (r) { return r.size; }).join(',');
      if (rt.sig === sig) return;
      var sameCount = rt.count === rows.length;
      rt.sig = sig;
      if (sameCount && rt.out.children.length) {
        rt.out.querySelectorAll('select[data-rf-row]').forEach(function (s) { var r = rows[+s.getAttribute('data-rf-row')]; if (r && s.value !== r.size) s.value = r.size; });
        return;
      }
      rt.count = rows.length;
      rt.out.innerHTML = rows.map(function (r, i) {
        return rt.html
          .replace(/\s(?:onchange|onChange)="\[\[row\.onSize\]\]"/g, ' data-rf-row="' + i + '"')
          .replace(/\[\[row\.(\w+)\]\]/g, function (m, k) { return esc(r[k] == null ? '' : r[k]); });
      }).join('');
      rt.out.querySelectorAll('select[data-rf-row]').forEach(function (s) { s.value = rows[+s.getAttribute('data-rf-row')].size; });
    });
  }

  function apply() {
    scheduled = false;
    var v = vals = comp.renderVals();
    var rs = document.documentElement.style;
    for (var i = 0; i < STYLE_VARS.length; i++) { var k = STYLE_VARS[i]; if (k in v) rs.setProperty('--rf-' + k, String(v[k])); }
    document.querySelectorAll('[data-rf-text]').forEach(function (el) {
      var key = el.getAttribute('data-rf-text'); if (!(key in v)) return;
      var s = String(v[key]); if (el.textContent !== s) el.textContent = s;
    });
    document.querySelectorAll('rf-if[data-rf-if]').forEach(function (el) { el.hidden = !v[el.getAttribute('data-rf-if')]; });
    attrBindings.forEach(function (b) { if (b.key in v) { var s = String(v[b.key]); if (b.el.getAttribute(b.attr) !== s) b.el.setAttribute(b.attr, s); } });
    renderRows(v);
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(apply); } }
  comp.onChange = schedule;

  /* ---------------- cart ---------------- */
  function cartJSON(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ('HTTP ' + r.status)); return j; }); });
  }
  function isGlove(id) { return (RF.gloveVariantIds || []).indexOf(Number(id)) > -1; }
  // free gifts by tier: Recovery Plan with 1+ pairs, Survival Guide + Glove Care & Travel Set with 2+ (from RF.gifts, set in rf-config); the travel pouch ships with every pair
  function gifts() { return RF.gifts && RF.gifts.length ? RF.gifts : (RF.bag ? [{ id: RF.bag, min: 2 }] : []); }
  function isGift(id) { return gifts().some(function (g) { return g.id === Number(id); }); }
  function addToCart(btn) {
    var pack = comp.state.pack, picked = comp.state.sizes.slice(0, pack), counts = {};
    picked.forEach(function (s) { counts[s] = (counts[s] || 0) + 1; });
    var items = Object.keys(counts).filter(function (s) { return RF.variants[s]; }).map(function (s) { return { id: RF.variants[s], quantity: counts[s] }; });
    if (!items.length) return;
    gifts().forEach(function (g) { if (pack >= g.min) items.push({ id: g.id, quantity: 1 }); });
    var label = btn.innerHTML; btn.disabled = true; btn.style.opacity = '0.7';
    // one bundle per cart: clear existing glove + gift lines first, then add this bundle with its gifts
    cartJSON('/cart.js').then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (isGlove(it.variant_id) || isGift(it.variant_id)) updates[it.key] = 0; });
      return Object.keys(updates).length ? cartJSON('/cart/update.js', { updates: updates }) : null;
    }).then(function () { return cartJSON('/cart/add.js', { items: items }); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (e) { btn.disabled = false; btn.style.opacity = ''; btn.innerHTML = label; alert('Sorry, we could not add that to your cart: ' + e.message); });
  }

  // keep gifts in step with the pairs in the cart: each gift once while its tier is met, removed below it
  var guarding = false;
  function guardCart() {
    if (guarding || !gifts().length) return; guarding = true;
    cartJSON('/cart.js').then(function (cart) {
      var pairs = 0, lines = {};
      cart.items.forEach(function (it) { if (isGlove(it.variant_id)) pairs += it.quantity; if (isGift(it.variant_id)) lines[it.variant_id] = it; });
      var updates = {}, adds = [];
      gifts().forEach(function (g) {
        var want = pairs >= g.min ? 1 : 0, line = lines[g.id], have = line ? line.quantity : 0;
        if (want === have) return;
        if (line) updates[line.key] = want; else adds.push({ id: g.id, quantity: 1 });
      });
      var hasUpd = Object.keys(updates).length > 0;
      if (!hasUpd && !adds.length) return false;
      return (hasUpd ? cartJSON('/cart/update.js', { updates: updates }) : Promise.resolve())
        .then(function () { return adds.length ? cartJSON('/cart/add.js', { items: adds }) : null; })
        .then(function () { return true; });
    }).then(function (changed) { guarding = false; if (changed && /^\/cart\/?$/.test(location.pathname)) location.reload(); })
      .catch(function () { guarding = false; });
  }
  if (window.fetch && !window.__rfFetchWrapped) {
    window.__rfFetchWrapped = true;
    var _f = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var pr = _f.apply(this, arguments);
      if (/\/cart\/(change|update)/.test(url) && !guarding) pr.then(function () { setTimeout(guardCart, 60); });
      return pr;
    };
  }

  /* ---------------- boot ---------------- */
  function boot() {
    document.querySelectorAll('*').forEach(function (el) {
      for (var i = 0; i < el.attributes.length; i++) {
        var a = el.attributes[i];
        if (a.name.indexOf('data-rf-attr-') === 0) attrBindings.push({ el: el, attr: a.name.slice(13), key: a.value });
      }
    });
    document.querySelectorAll('template[data-rf-for]').forEach(function (t) {
      var out = t.nextElementSibling;
      if (out && out.tagName === 'RF-FOR') rowTemplates.push({ key: t.getAttribute('data-rf-for'), html: t.innerHTML, out: out, sig: null, count: -1 });
    });
    document.addEventListener('click', function (e) {
      var atc = e.target.closest && e.target.closest('[data-rf-atc]');
      if (atc) { e.preventDefault(); addToCart(atc); return; }
      var t = e.target.closest && e.target.closest('[data-rf-on-click]');
      if (!t || !vals) return;
      var fn = vals[t.getAttribute('data-rf-on-click')];
      if (typeof fn === 'function') fn(e);
    });
    // header menu: on a same-page anchor, let the mobile menu close first, then scroll to the section (otherwise the menu collapse shifts the page past it)
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('header a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1), el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      setTimeout(function () {
        var hd = document.querySelector('header'), off = hd && getComputedStyle(hd).position === 'sticky' ? hd.getBoundingClientRect().height : 0;
        window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off - 8, behavior: 'smooth' });
        try { history.replaceState(null, '', '#' + id); } catch (_) {}
      }, 80);
    });
    document.addEventListener('change', function (e) {
      var s = e.target;
      if (s && s.hasAttribute && s.hasAttribute('data-rf-row')) comp.setPairSize(+s.getAttribute('data-rf-row'), s.value);
    });
    var ref = document.querySelector('[data-rf-ref]');
    apply();
    if (ref && vals && typeof vals[ref.getAttribute('data-rf-ref')] === 'function') vals[ref.getAttribute('data-rf-ref')](ref);

    setInterval(function () {
      comp.setState(function (s) {
        var left = s.left, hrs = s.hrs, mins = s.mins, secs = s.secs - 1;
        if (secs < 0) { secs = 59; mins -= 1; }
        if (mins < 0) { mins = 59; hrs -= 1; }
        if (hrs < 0) { hrs = 23; left -= 1; }
        if (left < 0) { left = 3; hrs = 11; mins = 42; secs = 18; }
        return { left: left, hrs: hrs, mins: mins, secs: secs };
      });
    }, 1000);
    var onResize = function () { var n = window.innerWidth < 980; if (n !== comp.state.narrow) comp.setState({ narrow: n }); };
    window.addEventListener('resize', onResize);
    var onScroll = function () {
      var box = document.getElementById('pricing'); if (!box) return;
      var r = box.getBoundingClientRect();
      var past = r.bottom < 80 || r.top < -220;
      if (past !== comp.state.stuck) comp.setState({ stuck: past });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    setInterval(function () { if (comp.state.narrow) comp.setState(function (s) { return { trustIdx: s.trustIdx === 0 ? 1 : 0 }; }); }, 5000);
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape' && comp.state.sizingOpen) comp.setState({ sizingOpen: false }); });
    if (/^\/cart\/?$/.test(location.pathname)) guardCart();
    window.RF_COMPONENT = comp;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
